/**
 *  分模块翻译，方便维护
 *  lang/en-US/module/nav.js
 */

export default {
  "nav": {
    "title": "icHub, One-Stop Solution!",
    "keywords": "Semiconductors, Integrated Circuits, Chips, ICs, Components, Supply Chain, BOM, Distribution, Agency, Trading, E-commerce, Platforms",
    "description": "icHub is a Chip and Component Trading Platform – Empowering the Entire Supply Chain with Communication and Trading Services",

    "search": "Search",
    "shop_name": "icHub Supply Chain Management (Shenzhen) Co., Ltd.",
    "short_shop_name": "icHub",
    "user": "User",
    "hot": "hot",
    "visit": "Visit",
    "service": "SP",
    "dealership": "DIST",
    "search_history": "Search History",

    "cms": "CMS",
    "info": "Shop",
    "biz": "Biz",
    "cart": "Cart",
    "order": "Order",
    "setting": "Setting",
    "erp": "ERP",
    "store": "Store",

    "home": "Home",
    "sku": "SKU",
    "shop": "Shop",
    "member": "Member",
    "spu": "SPU",
    "brand": "Brand",
    "category": "Categ",
    "post": "Post",
    "image": "Image",
    "all": "All",

    "like": "Like",
    "favorite": "Favorite",
    "message": "Message",

    "trending": "Trending",
    "comment": "Comment",
    "topic": "Topic",
    "last_week": "Last Week",
    "last_month": "Last Month",
    "recommend": "Recommend",
    "self_recommend": "Self Recommend",
    "invitation": "Invitation",
    "notice": "Notice",
    "statistics": "Stats",
    "label": "Label",
    "more":"More"
  }
};